import React from "react";

const EmployeeDashboard = () => {
  return <div></div>;
};

export default EmployeeDashboard;
